import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { GroupDetails } from "./components/GroupDetails";

export function GroupPage() {
  return (
    <LqsPage title="Group Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <GroupDetails />
      </Container>
    </LqsPage>
  );
}
